import handTouch from "assets/images/gif/hand-touch.gif";
import AddItem from "assets/images/icons/add-item.png";
import AllCheckNotSelected from "assets/images/icons/all-check-not-selected.png";
import AllCheckSelected from "assets/images/icons/all-check-selected.png";
import All from "assets/images/icons/all.png";
import Amex from "assets/images/icons/amex.png";
import Announcement from "assets/images/icons/announcement-black.png";
import HoverAnnouncement from "assets/images/icons/announcement-red.png";
import ArrowJumpIcon from "assets/images/icons/arrow-jump.png";
import LeftArrow from "assets/images/icons/arrow-left.svg";
import RedRightIcon from "assets/images/icons/arrow-right-red.png";
import RightArrow from "assets/images/icons/arrow-right.svg";
import BackNavigate from "assets/images/icons/back-navigate.png";
import Back from "assets/images/icons/back.png";
import BillCard from "assets/images/icons/bill-card.png";
import Book from "assets/images/icons/book.png";
import CallCenter from "assets/images/icons/call_center.png";
import Calculate from "assets/images/icons/calculate.png";
import Jcb from "assets/images/icons/card-jcb-icon.png";
import NotCheckedIcon from "assets/images/icons/check-default.png";
import CheckedIcon from "assets/images/icons/check-selected.png";
import CheckedSuccess from "assets/images/icons/checked-success.png";
import CloseEye from "assets/images/icons/close-eye-icon.png";
import Close from "assets/images/icons/close.svg";
import Copy from "assets/images/icons/copied.png";
import creditDate from "assets/images/icons/creditcard_date.png";
import DinersClub from "assets/images/icons/diners_icon.png";
import Discard from "assets/images/icons/discard.png";
import Dots from "assets/images/icons/dots.svg";
import Error from "assets/images/icons/error.svg";
import ExampleDashboard from "assets/images/icons/exampleDasboard.png";
import ExcelGrey from "assets/images/icons/excel-grey.svg";
import Excel from "assets/images/icons/excel.png";
import FolderSearchValidation from "assets/images/icons/folder-search-validation.png";
import FolderSearch from "assets/images/icons/folder-search.png";
import GetPasswordLarge from "assets/images/icons/get-password-large.png";
import GetPassword from "assets/images/icons/get-password.png";
import GetPasswordEn from "assets/images/icons/get-password-en.png";
import Home from "assets/images/icons/home.svg";
import Human from "assets/images/icons/human.png";
import ImageIcon from "assets/images/icons/image.png";
import Info from "assets/images/icons/info.png";
import IntroNext from "assets/images/icons/intro-next.png";
import IntroPrevious from "assets/images/icons/intro-previous.png";
import LockIcon from "assets/images/icons/lock.png";
import Logout from "assets/images/icons/logout.png";
import MasterCard from "assets/images/icons/master-card.png";
import Merchant from "assets/images/icons/merchant.svg";
import calendar from "assets/images/icons/misc_calendar.png";
import MobileMerchant from "assets/images/icons/mobile-merchant.png";
import MobileSettings from "assets/images/icons/mobile-settings.png";
import ModalClose from "assets/images/icons/modal-close.png";
import OpenEye from "assets/images/icons/open-eye-icon.png";
import pause from "assets/images/icons/pause.png";
import Pdf from "assets/images/icons/pdf.png";
import PermissionKey from "assets/images/icons/permission_auth.png";
import play from "assets/images/icons/play.png";
import Profile from "assets/images/icons/profile.png";
import Terminals from "assets/images/icons/terminals.png";
import Employees from "assets/images/icons/employees.png";
import Star from "assets/images/icons/star.png";
import Support from "assets/images/icons/support.png";
import QuestionMark from "assets/images/icons/question-mark.png";
import RadioNotSelected from "assets/images/icons/radio-not-selected.png";
import RadioSelected from "assets/images/icons/radio-selected.png";
import Refresh from "assets/images/icons/recurrent.png";
import Repeat from "assets/images/icons/repeat.png";
import SandWatchIcon from "assets/images/icons/sand-box.png";
import Search from "assets/images/icons/search.png";
import SecurityNotSelected from "assets/images/icons/security-not-selected.png";
import SecuritySelected from "assets/images/icons/security-selected.png";
import Settings from "assets/images/icons/settings.png";
import Show from "assets/images/icons/show.png";
import Slash from "assets/images/icons/slash.png";
import SortBy from "assets/images/icons/sort-by.png";
import SortByWhite from "assets/images/icons/sort-white.png";
import stop from "assets/images/icons/stop.png";
import Success from "assets/images/icons/success.png";
import Delete from "assets/images/icons/table-delete.png";
import Detail from "assets/images/icons/table-detail.png";
import Edit from "assets/images/icons/table-edit.png";
import Order from "assets/images/icons/table-order.png";
import RoleAssign from "assets/images/icons/table-role-assign.png";
import ThreeDotHorizontal from "assets/images/icons/three-dot-horizontal.png";
import TickIcon from "assets/images/icons/tick-circle-icon.svg";
import TimeoutIcon from "assets/images/icons/timeout.png";
import Tooltip from "assets/images/icons/tooltip-icon.svg";
import Troy from "assets/images/icons/troy-logo.png";
import Txt from "assets/images/icons/txt.png";
import UnionPay from "assets/images/icons/union.png";
import DefaultCard from "assets/images/icons/unkown-card-icon.png";
import User from "assets/images/icons/user.png";
import UserAddIcon from "assets/images/icons/user_add.png";
import ValidationError from "assets/images/icons/validation-error.png";
import VerticalDots from "assets/images/icons/vertical-dots.png";
import Visa from "assets/images/icons/visa.png";
import Warning from "assets/images/icons/warning.png";
import WhiteUser from "assets/images/icons/white-user.png";
import SimCard from "assets/images/icons/sim_card.png";
import PasswordSecurity from "assets/images/icons/password_security_icon.png";
import AkbankLogo from "assets/images/logo/akbank.svg";
import Business from "assets/images/icons/bussines.png";
import Telephone from "assets/images/icons/telefon.png";
import MobilePhone from "assets/images/icons/mobilePhone.png";
import Email from "assets/images/icons/email.png";

export interface IconProps {
  ARROW_JUMP: string;
  HOVER_ANNOUNCEMENT: string;
  MOBILE_SETTINGS: string;
  SUCCESS: string;
  LOCK: string;
  CHECKED: string;
  NOTCHECKED: string;
  BURGER: string;
  ANNOUNCEMENT: string;
  INFO: string;
  LOGOUT: string;
  SETTINGS: string;
  VALIDATION_ERROR: string;
  BILL_CARD: string;
  HUMAN: string;
  CALCULATE: string;
  CALL_CENTER: string;
  MERCHANT: string;
  OPEN_EYE: string;
  CLOSE_EYE: string;
  MOBILE_MERCHANT: string;
  GETPASSWORD: string;
  GETPASSWORD_EN: string;
  REDRIGHT: string;
  REPEAT: string;
  CLOSE: string;
  REFRESH: string;
  GETPASSWORDLARGE: string;
  SECURITY_SELECTED: string;
  SECURITY_NOT_SELECTED: string;
  RADIO_SELECTED: string;
  RADIO_NOT_SELECTED: string;
  MODAL_CLOSE: string;
  USER: string;
  WARNING: string;
  ERROR: string;
  TICK: string;
  ORDER: string;
  EDIT: string;
  DETAIL: string;
  LEFT: string;
  DELETE: string;
  THREE_DOT_HORIZONTAL: string;
  WHITE_USER: string;
  SIM_CARD: string;
  PASSWORD_SECURITY: string;
  ROLE_ASSIGN: string;
  SEARCH: string;
  VISA: string;
  MASTERCARD: string;
  AMEX: string;
  VERTICAL_DOTS: string;
  PROFILE: string;
  TERMINALS: string;
  EMPLOYEES: string;
  STAR: string;
  SUPPORT: string;
  QUESTION_MARK: string;
  RIGHT: string;
  BOOK: string;
  EXAMPLE_DASHBOARD: string;
  CHECKED_SUCCESS: string;
  IMAGE: string;
  EXCEL: string;
  PDF: string;
  TXT: string;
  FOLDER_SEARCH: string;
  FOLDER_SEARCH_VALIDATION: string;
  SHOW: string;
  DEFAULT_CARD: string;
  TIMEOUT: string;
  SAND_WATCH: string;
  USER_ADD: string;
  BACK: string;
  TOOLTIP: string;
  ALL_CHECK_NOT_SELECTED: string;
  ALL_CHECK_SELECTED: string;
  BACK_NAVIGATE: string;
  DISCARD: string;
  EXCEL_GREY: string;
  DOTS: string;
  ADD_ITEM: string;
  SORT_BY: string;
  SORT_BY_WHITE: string;
  COPY: string;
  CALENDAR: string;
  CREDIT_CARD_DATE: string;
  SLASH: string;
  PERMISSION_KEY: string;
  PLAY: string;
  STOP: string;
  PAUSE: string;
  INTRO_PREVIOUS: string;
  INTRO_NEXT: string;
  BUSINESS: string;
  TELEPHONE: string;
  MOBILEPHONE: string;
  EMAIL: string;
}

export const ICONS: IconProps = {
  ARROW_JUMP: ArrowJumpIcon,
  ALL_CHECK_NOT_SELECTED: AllCheckNotSelected,
  ALL_CHECK_SELECTED: AllCheckSelected,
  SUCCESS: Success,
  HOVER_ANNOUNCEMENT: HoverAnnouncement,
  CLOSE: Close,
  HOME: Home,
  OPEN_EYE: OpenEye,
  CLOSE_EYE: CloseEye,
  MOBILE_SETTINGS: MobileSettings,
  LOCK: LockIcon,
  VALIDATION_ERROR: ValidationError,
  CHECKED: CheckedIcon,
  NOTCHECKED: NotCheckedIcon,
  BURGER: All,
  ANNOUNCEMENT: Announcement,
  INFO: Info,
  LOGOUT: Logout,
  SETTINGS: Settings,
  BILL_CARD: BillCard,
  HUMAN: Human,
  CALCULATE: Calculate,
  CALL_CENTER: CallCenter,
  MERCHANT: Merchant,
  MOBILE_MERCHANT: MobileMerchant,
  GETPASSWORD: GetPassword,
  GETPASSWORD_EN: GetPasswordEn,
  REDRIGHT: RedRightIcon,
  REPEAT: Repeat,
  REFRESH: Refresh,
  GETPASSWORDLARGE: GetPasswordLarge,
  TOOLTIP: Tooltip,
  SECURITY_SELECTED: SecuritySelected,
  SECURITY_NOT_SELECTED: SecurityNotSelected,
  RADIO_SELECTED: RadioSelected,
  RADIO_NOT_SELECTED: RadioNotSelected,
  MODAL_CLOSE: ModalClose,
  USER: User,
  WARNING: Warning,
  ORDER: Order,
  EDIT: Edit,
  RIGHT: RightArrow,
  LEFT: LeftArrow,
  DETAIL: Detail,
  DELETE: Delete,
  THREE_DOT_HORIZONTAL: ThreeDotHorizontal,
  WHITE_USER: WhiteUser,
  SIM_CARD: SimCard,
  PASSWORD_SECURITY: PasswordSecurity,
  ROLE_ASSIGN: RoleAssign,
  SEARCH: Search,
  VISA: Visa,
  MASTERCARD: MasterCard,
  TICK: TickIcon,
  DINERSCLUB: DinersClub,
  JCB: Jcb,
  UNIONPAY: UnionPay,
  DEFAULT_CARD: DefaultCard,
  AMEX: Amex,
  TROY: Troy,
  VERTICAL_DOTS: VerticalDots,
  PROFILE: Profile,
  TERMINALS: Terminals,
  EMPLOYEES: Employees,
  STAR: Star,
  SUPPORT: Support,
  QUESTION_MARK: QuestionMark,
  BOOK: Book,
  EXAMPLE_DASHBOARD: ExampleDashboard,
  CHECKED_SUCCESS: CheckedSuccess,
  IMAGE: ImageIcon,
  DOTS: Dots,
  EXCEL: Excel,
  EXCEL_GREY: ExcelGrey,
  PDF: Pdf,
  TXT: Txt,
  FOLDER_SEARCH: FolderSearch,
  FOLDER_SEARCH_VALIDATION: FolderSearchValidation,
  SHOW: Show,
  ERROR: Error,
  TIMEOUT: TimeoutIcon,
  SAND_WATCH: SandWatchIcon,
  USER_ADD: UserAddIcon,
  BACK: Back,
  BACK_NAVIGATE: BackNavigate,
  DISCARD: Discard,
  ADD_ITEM: AddItem,
  SORT_BY: SortBy,
  SORT_BY_WHITE: SortByWhite,
  COPY: Copy,
  CALENDAR: calendar,
  CREDIT_CARD_DATE: creditDate,
  SLASH: Slash,
  PERMISSION_KEY: PermissionKey,
  PLAY: play,
  STOP: stop,
  PAUSE: pause,
  INTRO_PREVIOUS: IntroPrevious,
  INTRO_NEXT: IntroNext,
  BUSINESS: Business,
  TELEPHONE: Telephone,
  MOBILEPHONE: MobilePhone,
  EMAIL: Email,
} as IconProps;

export default ICONS;

export interface LogoProps {
  AKBANK: string;
}

export const LOGOS: LogoProps = {
  AKBANK: AkbankLogo,
} as LogoProps;

export interface GifProps {
  HAND_TOUCH: string;
}

export const GIFS: GifProps = {
  HAND_TOUCH: handTouch,
} as GifProps;
